// When forceEnabled is false, we query a URL to know if we should enable or disable registrations
exports.registration = {
    forceEnabled: false,
};
